export function NullSettings() {
  return null;
}

export default NullSettings;
